import type { ReactNode } from 'react';
import { AppstoreOutlined, BookOutlined, CheckSquareOutlined, ColumnWidthOutlined, DashboardOutlined, MobileOutlined, PictureOutlined, SearchOutlined } from '@ant-design/icons';

export interface RouteDef {
  path: string;
  label: string;
  icon: ReactNode;
  description: string;
  /** 구현 예정 Issue 번호 */
  issues: number[];
}

// 메뉴 순서는 요구사항 R2 §6의 화면 책임 구분을 따른다.
export const ROUTES: RouteDef[] = [
  { path: '/', label: '운영 대시보드', icon: <DashboardOutlined />, description: '어휘·이미지 구축 현황, 앱 버전·배포, CDN·Firebase 상태 조회', issues: [12, 96] },
  { path: '/versions', label: '버전별 리소스', icon: <AppstoreOutlined />, description: '앱 버전별 기본 카드·이미지 조회', issues: [11] },
  { path: '/search', label: '검색 결과 확인', icon: <SearchOutlined />, description: '실제 앱의 카드명·태그 기반 이미지 검색 결과', issues: [10] },
  { path: '/preview', label: '실물 크기 검수', icon: <ColumnWidthOutlined />, description: '3cm·5cm 실물 크기 비교와 화면 보정', issues: [9] },
  { path: '/vocab', label: '어휘 관리', icon: <BookOutlined />, description: '한국어 AAC 핵심·주변어휘와 이미지 구축 현황', issues: [14] },
  { path: '/images', label: '이미지 제작', icon: <PictureOutlined />, description: '자동·수동 생성, 검수, 게시', issues: [15, 16, 17] },
  { path: '/review', label: '검수함', icon: <CheckSquareOutlined />, description: '생성 후보 비교·판정', issues: [53] },
  { path: '/qa', label: '실기기 점검', icon: <MobileOutlined />, description: '배포별 실기기 TC 결과 기록과 이슈 판정', issues: [111] },
];
